import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductConversionService } from 'src/app/services/product-conversion.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { TransformationProduct,TransformationProductItem} from 'src/app/models/product.model';
import { ProductService } from 'src/app/services/product.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ResponseObject } from 'src/app/models/response-object.model';

export interface ProductResponse {
    id: number;
    code: string;
    name: string;
}

export interface TargetProductConversionData {
    targetProduct: ProductResponse;
    factor: number;
}

export interface ProductConversionData {
    product: ProductResponse;
    existingQuantity: number;
    targetProducts: TargetProductConversionData[];
}


export interface ProductConversionView
    extends ProductConversionData {
    selectedTargetProductId: number | null;
    selectedTransformation:
        TargetProductConversionData | null;

}


@Component({
    selector: 'app-products-posible-transformation',
    templateUrl:
        './products-posible-transformation.component.html',
    styleUrls: [
        './products-posible-transformation.component.scss'
    ]

})

export class ProductsPosibleTransformationComponent
    implements OnInit {
    loading = false;
    loadingWarehouses = false;
    savingProductId: number | null = null;
    products: ProductConversionView[] = [];
    warehouses: any[] = [];
    selectedWarehouse: any = null;
    inputs: any = {
        warehouse: {
            filterElements: [],
            verified: false,
            value: ''
        }
    };
    selectedWarehouseId: number | null = null;
    constructor(

        private productConversionService:
            ProductConversionService,

        private toastr:
            ToastrService,

        private warehouseService:
            WarehouseService,

        private productService:
            ProductService

    ) {

    }

    ngOnInit(): void {
        this.loadWarehouses();
    }


    loadWarehouses(): void {
        this.loadingWarehouses = true;

        this.warehouseService
            .getWarehouses()
            .subscribe({

                next: (response: any) => {

                    this.warehouses =
                        Array.isArray(response)
                            ? response
                            : response?.data || [];

                    this.loadingWarehouses = false;

                },

                error: (error) => {

                    console.error(
                        'Error obteniendo bodegas',
                        error
                    );

                    this.warehouses = [];

                    this.loadingWarehouses = false;

                    this.toastr.error(
                        'No fue posible obtener las bodegas.'
                    );

                }

            });

    }

    onWarehouseChange(
        warehouseId: number | null
    ): void {

        this.products = [];

        this.selectedWarehouse = null;


        if (!warehouseId) {

            return;

        }


        const warehouse =
            this.warehouses.find(
                item => item.id === warehouseId
            );


        if (!warehouse) {

            return;

        }


        this.selectedWarehouse =
            warehouse;


        this.loadProducts();

    }

    writeWarehouse(
        value: string,
        input: any
    ): void {

        const search =
            (value || '')
                .trim()
                .toLowerCase();


        // Si el autocomplete está escribiendo el nombre
        // del elemento que acabamos de seleccionar,
        // no borramos la selección.
        if (
            this.selectedWarehouse &&
            search ===
                String(
                    this.selectedWarehouse.name || ''
                )
                    .trim()
                    .toLowerCase()
        ) {

            return;

        }


        this.selectedWarehouse = null;

        input.verified = false;

        this.products = [];


        // Si no hay texto, mostrar otra vez todas.
        if (!search) {

            input.filterElements =
                [...this.warehouses];

            return;

        }


        input.filterElements =
            this.warehouses.filter(
                (warehouse: any) => {

                    const name =
                        String(
                            warehouse.name || ''
                        ).toLowerCase();

                    const code =
                        String(
                            warehouse.code || ''
                        ).toLowerCase();

                    const address =
                        String(
                            warehouse.address || ''
                        ).toLowerCase();


                    return (
                        name.includes(search) ||
                        code.includes(search) ||
                        address.includes(search)
                    );

                }
            );

    }


    // =====================================================
    // SELECCIONAR BODEGA
    // =====================================================

    selectWarehouse(
        warehouse: any,
        input: any
    ): void {

        console.log(
            'Evento selección:',
            warehouse
        );


        if (!warehouse || !warehouse.id) {

            return;

        }


        this.selectedWarehouse =
            warehouse;


        input.verified =
            true;


        // NO limpiar filterElements aquí.
        // Eso era parte del problema.


        console.log(
            'Bodega seleccionada:',
            this.selectedWarehouse
        );


        this.loadProducts();

    }


    // =====================================================
    // CARGAR PRODUCTOS DE LA BODEGA
    // =====================================================

    loadProducts(): void {

    if (!this.selectedWarehouse?.id) {

        this.products = [];

        return;

    }


    this.loading = true;


    this.productConversionService
        .getProductsConversion(
            this.selectedWarehouse.id
        )
        .subscribe({

            next: (response: any) => {

                const data: ProductConversionData[] =
                    Array.isArray(response)
                        ? response
                        : response?.data || [];


                this.products = data.map(
                    (item: ProductConversionData) => ({

                        ...item,

                        targetProducts:
                            item.targetProducts || [],

                        selectedTargetProductId:
                            null,

                        selectedTransformation:
                            null

                    })
                );


                this.loading = false;

            },

            error: (error) => {

                console.error(
                    'Error obteniendo posibles transformaciones',
                    error
                );

                this.products = [];

                this.loading = false;

                this.toastr.error(
                    'No fue posible obtener los productos disponibles.'
                );

            }

        });

}


    // =====================================================
    // CAMBIO DE PRODUCTO DESTINO
    // =====================================================

    onTransformationChange(
        product: ProductConversionView
    ): void {

        if (!product.selectedTargetProductId) {

            product.selectedTransformation =
                null;

            return;

        }


        const transformation =
            product.targetProducts.find(

                item =>
                    item.targetProduct.id ===
                    product.selectedTargetProductId

            );


        product.selectedTransformation =
            transformation || null;

    }


    // =====================================================
    // CALCULAR RESULTADO
    // =====================================================

    calculateResult(
        product: ProductConversionView
    ): number {

        if (!product.selectedTransformation) {

            return 0;

        }


        const quantity =
            Number(
                product.existingQuantity || 0
            );


        const factor =
            Number(
                product
                    .selectedTransformation
                    .factor || 0
            );


        return quantity * factor;

    }


    // =====================================================
    // TRANSFORMAR PRODUCTO
    // =====================================================

    transformProduct(
        product: ProductConversionView
    ): void {

        // =====================================================
        // VALIDACIONES
        // =====================================================

        if (!this.selectedWarehouse) {

            this.toastr.warning(
                'Debe seleccionar una bodega.'
            );

            return;

        }


        if (!product.selectedTransformation) {

            this.toastr.warning(
                'Debe seleccionar un producto de transformación.'
            );

            return;

        }


        if (
            !product.existingQuantity ||
            Number(product.existingQuantity) <= 0
        ) {

            this.toastr.warning(
                'El producto no tiene existencia disponible.'
            );

            return;

        }


        if (this.loading) {

            return;

        }


        const transformation =
            product.selectedTransformation;


        const targetProduct =
            transformation.targetProduct;


        const sourceQuantity =
            Number(product.existingQuantity);


        const resultQuantity =
            this.calculateResult(product);


        // =====================================================
        // CREAR TRANSFORMATION PRODUCT
        // =====================================================

        const request =
            new TransformationProduct();


        request.transformation = true;


        // =====================================================
        // BODEGA
        //
        // En una transformación la bodega origen y destino
        // es la misma.
        // =====================================================

        request.fromWarehouse =
            this.selectedWarehouse.id;

        request.fromWarehouseName =
            this.selectedWarehouse.name;


        request.toWarehouse =
            this.selectedWarehouse.id;

        request.toWarehouseName =
            this.selectedWarehouse.name;


        // =====================================================
        // FECHAS
        // =====================================================

        const now =
            new Date();


        request.issuedDate =
            now.getTime();


        request.expectedDate =
            now.getTime();


        // =====================================================
        // PRODUCTO ORIGEN
        // =====================================================

        request.fromProducts = [];


        const fromProduct =
            new TransformationProductItem();


        fromProduct.productId =
            product.product.id;

        fromProduct.productName =
            product.product.name;

        fromProduct.quantity =
            sourceQuantity;

        fromProduct.existence =
            sourceQuantity;

        fromProduct.costPercentage =
            0;


        request.fromProducts.push(
            fromProduct
        );


        // =====================================================
        // PRODUCTO RESULTANTE
        // =====================================================

        request.toProducts = [];


        const toProduct =
            new TransformationProductItem();


        toProduct.productId =
            targetProduct.id;

        toProduct.productName =
            targetProduct.name;

        toProduct.quantity =
            resultQuantity;

        toProduct.existence =
            null;

        /**
         * Solo tenemos un producto resultante,
         * por lo que recibe el 100% del costo.
         */
        toProduct.costPercentage =
            100;


        request.toProducts.push(
            toProduct
        );


        console.log(
            'Request transformación:',
            request
        );


        // =====================================================
        // EJECUTAR TRANSFORMACIÓN
        // =====================================================

        this.loading = true;

        this.savingProductId =
            product.product.id;


        // Primero se realiza exactamente la misma validación
        // que en la vista anterior.

        this.productService
            .transferProductValidation(request)
            .subscribe({

                next: () => {

                    // =========================================
                    // SI PASA VALIDACIÓN, TRANSFORMAR
                    // =========================================

                    this.productService
                        .transferProduct(request)
                        .subscribe({

                            next: (
                                response: ResponseObject
                            ) => {

                                console.log(
                                    'Transformación realizada:',
                                    response
                                );


                                this.toastr.success(
                                    'Producto transformado correctamente.'
                                );


                                this.loading = false;

                                this.savingProductId =
                                    null;


                                /**
                                 * Volvemos a consultar para
                                 * actualizar las existencias.
                                 */
                                this.loadProducts();

                            },


                            error: (
                                error: HttpErrorResponse
                            ) => {

                                console.error(
                                    'Error realizando transformación',
                                    error
                                );


                                this.loading = false;

                                this.savingProductId =
                                    null;


                                this.toastr.error(
                                    'No tiene existencias para la transacción en la fecha seleccionada, tiene compras con fechas posteriores a la operación.',
                                    'Error al realizar la transformación'
                                );

                            }

                        });

                },


                error: (
                    error: HttpErrorResponse
                ) => {

                    console.error(
                        'Error validando transformación',
                        error
                    );


                    this.loading = false;

                    this.savingProductId =
                        null;


                    this.toastr.error(
                        'La bodega seleccionada no tiene destino asignado.',
                        'Error al realizar la transformación'
                    );

                }

            });

    }


    // =====================================================
    // TRACK BY
    // =====================================================

    trackByProduct(
        index: number,
        product: ProductConversionView
    ): number {

        return product.product.id;

    }


    trackByTransformation(
        index: number,
        transformation:
            TargetProductConversionData
    ): number {

        return transformation.targetProduct.id;

    }

}